module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_05-053a3373475aad5627afac0a42977535.webp";